module.exports = __webpack_public_path__ + "img/hero.8dc43898.jpg";